<template>
  <div>
    <AppForm label="アクセス元地域">
      <v-btn @click="showModal = true">変更</v-btn>
      <v-layout key="country" v-if="setting.isIpAreaWholeCountry">
        日本全域
      </v-layout>
      <v-layout key="regions" v-if="setting.ipAreaType === 'region'">
        <v-flex>
          <v-chip
            v-for="ipAreaId in setting.ipAreaIds"
            :key="ipAreaId"
            @input="remove(ipAreaId)"
            color="blue"
            close
            outline
            ><RegionName :form="form" :id="ipAreaId"
          /></v-chip>
          <small v-if="setting.ipAreaIds.length === 0" class="red--text"
            >アクセスエリアを日本全域にするか、都道府県を1つ以上設定してください。</small
          >
        </v-flex>
      </v-layout>
    </AppForm>
    <ModalEdit
      v-if="showModal"
      v-model="showModal"
      :setting="setting"
      :regions="regions"
      @change="setting = $event"
    />
  </div>
</template>

<script>
import ModalEdit from './CampaignModalPageAdvancedIpAreaSettingModal'
import RegionName from './CampaignModalIpAreaRegionName'
import { IpAreaTypes } from '@/models/CampaignOperation/Constants'

export default {
  name: 'CampaignModalPageAdvancedIpAreaSetting',
  components: { ModalEdit, RegionName },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showModal: false,
    }
  },
  computed: {
    regions() {
      return this.form.ipAreaRegions
    },
    setting: {
      get() {
        return this.form.campaign.advancedSetting.ipAreaSetting
      },
      set(value) {
        this.form.campaign.advancedSetting.ipAreaSetting = value
      },
    },
  },
  methods: {
    remove(id) {
      this.setting.ipAreaIds = this.setting.ipAreaIds.filter(
        ipAreaId => ipAreaId !== id,
      )
      if (this.setting.ipAreaIds.length === 0) {
        this.form.campaign.advancedSetting.ipAreaSetting.changeIpAreaType(
          IpAreaTypes.COUNTRY,
        )
      }
    },
  },
}
</script>

<style></style>
